import { createSlice } from '@reduxjs/toolkit';
import { IMeetingDetail } from 'containers/Meeting/meetingTypes';
import { completeMeeting, getMeetingList } from './meetingActions';

interface IInitialState {
  loading: boolean;
  success: boolean;
  error: boolean;
  meetings: IMeetingDetail[];
  markingComplete: boolean;
  skipCount: number;
  totalCount: number;
}

const initialState: IInitialState = {
  loading: false,
  success: false,
  error: false,
  meetings: [],
  markingComplete: false,
  skipCount: 0,
  totalCount: 0,
};
const meetingSlice = createSlice({
  name: 'meeting',
  initialState,
  reducers: {
    resetMeeting(state) {
      state.meetings = [];
      //state.trackList = payload.tracks;
    },
    setSkipCount(state, action) {
      state.skipCount = action.payload > state.totalCount ? state.totalCount : action.payload;
      state.meetings = [];
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getMeetingList.pending, (state) => {
      state.error = false;
      state.success = false;
      state.loading = true;
    });
    builder.addCase(getMeetingList.fulfilled, (state, action) => {
      state.totalCount = action?.payload?.output?.totalCount;
      state.meetings = action?.payload?.output?.meetings;
      state.success = true;
      state.loading = false;
    });
    builder.addCase(getMeetingList.rejected, (state) => {
      state.error = true;
      state.loading = false;
    });
    builder.addCase(completeMeeting.pending, (state) => {
      state.error = false;
      state.success = false;
      state.markingComplete = true;
    });
    builder.addCase(completeMeeting.fulfilled, (state, action) => {
      state.success = true;
      state.markingComplete = false;
    });
    builder.addCase(completeMeeting.rejected, (state) => {
      state.error = true;
      state.markingComplete = false;
    });
  },
});

export const {
  reset,
  resetMeeting,
  setSkipCount
} = meetingSlice.actions;

export default meetingSlice.reducer;
